import { useQuery } from 'react-query'
import { api } from '../../api'
import { Dayjs } from 'dayjs'
import { PropriedadeItens } from '../../Propriedades'
import { errorAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'

export interface TypeGetOs {
  itens: [OsItensTypes]
  total: number
}

export interface OsItensTypes {
  cod?: number
  data?: string | Dayjs
  status?: number
  arquivo_processado_url: string
  areaTalhao?: string
  nome_cliente?: string
  calcario_propriedade?: string
  cod_laboratorio?: number
  laboratorio_nome?: string
  cod_propriedade?: number
  cod_talhao?: number
  cod_calcario?: number
  cod_cliente?: number
  create_user?: string
  create_time?: string
  update_user?: string
  update_time?: string
  talhao_nome?: string
  safra_nome?: string
  safra_consultoria_nome?: string
  cliente_nome?: string
  talhao_kml?: {
    coordenadas: { latitude: string; longitude: string }[]
    lookAt: { latitude: string; longitude: string }
    name?: string
  }
  cod_representante?: number
  data_liberada?: string | Dayjs
  data_coleta?: string | Dayjs
  talhao_area?: string
  propriedade_nome?: string
  cod_safra: number
  cod_safra_conta: number
  representante?: [
    {
      cidade_nome?: string
      cod?: number
      cpf?: string
      participacao?: string
      representante?: number
      solicitante?: string
      endereco: string
      endereco_cep: string
      endereco_complemento: string
      uf_nome?: string
      uf_sigla?: string
      usuario_nome?: string
    }
  ]
  historicoStatus?: [
    {
      cod: number
      cod_pedido: number
      cod_usuario: number
      /**
       * @param {status} 1 = Aberto | 2 = Liberado para coleta | 3 = Coletada | 4 = Em análise | 5 = Análisada | 6 = Resultado com inconsistencia | 7 = Enviado para análise
       */
      status: 1 | 2 | 3 | 4 | 5 | 6 | 7
      status_nome: string
      usuario_nome: string
    }
  ]
  propriedade: PropriedadeItens[]
  cod_responsaveis?: [number]
  solicitante?: string
  cod_area_amostra?: number
  malha_de_pontos?: {
    type?: string
    features?: []
    fileName?: string
  }
  analises?: [
    {
      title?: string
      cod_analises?: [
        {
          nome?: string
          cod: string
          valor: string
          cor: string
        }
      ]
      cod_profundidade?: number
      profundidade?: string
      id?: string
      pontos?: [
        {
          NOME: string
          INDICE: number
          COMENTARIO?: string
          LATITUDE: number
          LONGITUDE: number
          COR?: string | null
        }
      ]
      valor_analise?: string
    }
  ]
  responsaveis?: [
    {
      cod: number
      cod_pedido: number
      cod_responsavel: number
      responsavel_nome: string
    }
  ]
}

export const useGetOsColetaBook = (
  cod?: number,
  token?: string,
  codConta?: number,
  codSafra?: number,
  codCliente?: number,
  nome?: string,
  codPropriedade?: number,
  pagination = 15,
  page = 1
) => {
  const queryKey = [
    '/pedido-laboratorio',
    {
      cod,
      pagination,
      page,
      nome,
      token,
      codConta,
      codSafra,
      codCliente,
      codPropriedade,
    },
  ]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<TypeGetOs, Error>(
    queryKey,
    async ({ queryKey }) => {
      const tokenComplete = `Token ${process.env.REACT_APP_TOKEN_API}, Bearer ${token}`

      if (token !== null) {
        api.defaults.headers.Acesso = 'conta'
      } else {
        api.defaults.headers.Acesso = localConfig()?.acesso
      }
      return api
        .get('/pedido-laboratorio', {
          params: {
            pagination: pagination,
            page: page,
            nome: nome,
            codConta: localConfig()?.conta ?? codConta,
            codSafra: localConfig()?.codSafra ?? codSafra,
            codCliente: localConfig()?.codCliente ?? codCliente,
            codPropriedade: codPropriedade,
          },
          headers: {
            ...(token !== null && { Authorization: tokenComplete }),
          },
        })
        .then((response): any => response.data)
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista!')
          throw error
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data,
    carregando: isFetching,
    refetch_data: refetch,
    isFetched: isFetchedAfterMount,
    isError,
  }
}

export const useGetOsColetada = (
  pagination = 15,
  page = 1,
  nome?: string,
  codSafra?: number | string,
  codPropriedade?: number
) => {
  const queryKey: any = [`/pedido-laboratorio`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<TypeGetOs, Error>(
    queryKey,
    async () => {
      const paramNome = nome ? `&nome=${nome}` : ''
      const cod_propriedade = codPropriedade ? `&codPropriedade=${codPropriedade}` : ''
      return api
        .get(
          `/pedido-laboratorio?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&codSafra=${
            localConfig()?.codSafra
          }&${cod_propriedade}&pagination=${pagination}&page=${page}${paramNome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de inoculantes!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_osColeta: data,
    carregando_osColeta: isFetching,
    refetch_data_osColeta: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetOsColetadaEditar = (cod: number) => {
  const queryKey: any = [`/pedido-laboratorio_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<TypeGetOs, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/pedido-laboratorio?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&codSafra=${localConfig()?.codSafra}&cod=${cod}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de inoculantes!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_osColeta_editar: data,
    carregando_osColeta_editar: isFetching,
    refetch_data_osColeta_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
